export default "__VITE_ASSET__DGM9_A6___"